import React, {  useState,useRef, useEffect } from 'react';
import axios from 'axios';
import Modal from '../../Modal';
import Locations from './../CVLocations';
import { getUserId,aPIURL,auTHURL,pdfUrl} from '../../../utils/common';
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import LoadingSpinner from "../../LoadingSpinner";
import { useReactToPrint } from 'react-to-print';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
//import { useDownloadExcel } from "react-export-table-to-excel";
import Enumerate from "linq";
import { useNavigate  } from "react-router-dom";


const HistoryReport = () => 
{
    const [reportType,setReportType]= useState([]);
    const history = useNavigate();
    const fileType ="xlsx";
    const [tripNo,setTripNo]=useState("");
    const [reportID,setReportID]=useState("History Report");
    const [showEditDriver, setShowEditDriver] = useState(false); 
    const [sdate,setSdate]=useState();
    const [edate,setEdate]=useState();
    const[arrayvehicle,setArrayvehicle]=useState([]);
    const[arrayReportType,setArrayReportType]=useState([]);
    const [items,setItems]= useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);
    const API_URL=aPIURL();
    const AUTH_URL= auTHURL();
    const PDF_Url=pdfUrl();
    const [userId, setUserId]  = useState({});
    const [custID, setCustID]  = useState('0');
    const [dIMEINo, setDIMEINo]  = useState('0'); 
    const [devName, setDevName]  = useState(""); 
    const [dID, setDID]  = useState('0');
    const [vCategoryID, setVCategoryID]  = useState('0');
    const [post, setPost] = useState([]);
    const [temppost, setTempPost] = useState([]);
    const [searchpost, setSearchempPost] = useState([]);
    const [deviceData , setDeviceData]  =useState([]);
    const [filteredDevicedata,setFilteredDevicedata ]  =useState([]);
    const [vCategoryData,setVCategoryData ]  =useState([]);
    const [showDetails,setShowDetails ]  = useState(false);
    const [showLocation,setShowLocation ]  = useState(false);    
    const [showEditVehicle,setShowEditVehicle ]  = useState(false);    
    const [order, setOrder] = useState("ASC");
    const [number, setNumber] = useState(1); // No of pages
    const [postPerPage] = useState(10);
    const AccountID =getUserId(); 
    const [imeiNumber,setImeiNumber]=useState("");
    const [statusId, setStatusId]= useState(0);
    const [vehicleNo,setVehicleNo]=useState("");
    const [hisDisplay, setHisDisplay]= useState('none');
    const [distDisplay, setDistDisplay]=useState('none');
    const [stopDisplay, setStopDisplay]=useState('none');
    const [overSDisplay, setOverSDisplay]=useState('none');
    let [min_Date,setMin_Date]= useState("");
    const [rtpAddress, setRtpAddress] = useState("No");
  const sorting=(col)=>
  {

    try
    {
      if(order==="ASC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() > b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("DSC");
      }
      if(order==="DSC")
      {
              const sorted=[...post].sort((a,b)=>
              a[col].toLowerCase() < b[col].toLowerCase() ? 1: -1
              );
              setPost(sorted);
              setOrder("ASC");
      }
    }
    catch(error) 
    {
      console.log(error.message);
    }              
  }
  const getSixtyDaysAgoDate = () => 
  {
    const date = new Date();
    date.setDate(date.getDate() - 60);
     //return date.toISOString().split('T')[0]; 
     setMin_Date(date.toISOString().split('T')[0]);
  };
  useEffect(() => 
  {  
        FillReportType();
        FillVehicle(); 
        getSixtyDaysAgoDate();
    
  }, []);
  
        const lastPost = number * postPerPage;
        const firstPost = lastPost - postPerPage;
        const currentPost = post.slice(firstPost, lastPost);
        let PageCount = Math.ceil(post.length / postPerPage);

  const FillReportType=()=>
  {
            const rturls=API_URL+`ReportType`;
            setArrayReportType([]);
            //alert(rturls);
            axios.get(rturls).then(response => 
            {                            
                setArrayReportType(response.data.data)
        
            }).catch(function(error)
            {
                    console.log(error.message);
            });
         
  }
  const FillVehicle=()=>
  {
            const user_id = getUserId();
            const curls=API_URL+`VehicleList/?AccountID=${user_id}&TypeID=1`;
            setArrayvehicle([]);
            //alert(curls);
            axios.get(curls).then(response => 
            {                            
                    setArrayvehicle(response.data.data)     
                    
            }
            ).catch(function(error)
            {
                    console.log(error.message);
            });
      
  }
 
const GoToPage = (e) => 
{
       history(e);  
}; 
const getAddress = async (lat, lon) => {

    if (!lat || !lon) {
        return "Address Not Available";
    }

    try {

        const response = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`,
            {
                timeout: 10000,
                headers: {
                    Accept: "application/json"
                }
            }
        );

        return response.data?.display_name || "Address Not Found";

    } catch (error) {

        console.log("Geocoding Error:", error);

        return "Address Not Found";
    }
};
const FillGrid = async (Type_ID) => {
    setIsLoading(true);

    let url = "";

    if (reportID === "History Report") {
        url = API_URL +
            `GetGPSHistory/?FromDate=01-01-2020&ToDate=04-04-2030&IEMI=${imeiNumber}`;
    }

    setPost([]);

    try {

        const response = await axios.post(url);

        let data = response.data.data;

        // Only fetch addresses when needed
       if (rtpAddress === "Yes") {
          data = await Promise.all(
          data.map(async (item) => {

            if (!item.startAddress?.trim()) {
                item.startAddress = await getAddress(
                    item.start_Latitude,
                    item.start_Longitude
                );
            }

            if (!item.endAddress?.trim()) {
                item.endAddress = await getAddress(
                    item.end_Latitude,
                    item.end_Longitude
                );
            }

            return item;
        })
    );
    }

        setPost(data);
        setIsLoading(false);

    } catch (error) {

        setIsLoading(false);
        console.log(error.message);
    }
};
const SearchFillGrid=(IMEI)=>
  {
      setIsLoading(true);
      const url="";  
      if(reportID =="History Report")
        {
             url=API_URL+`GetGPSHistory/?FromDate=01-01-2020&ToDate=04-04-2030&IEMI=${IMEI}`;
        }
      setPost([]); 
      setTempPost([]);
      axios.post(url).then(response => 
        {  
            setIsLoading(false);
            console.log(response.data.data);        
            setPost(response.data.data)   
            setTempPost(response.data.data);
        }).catch(function(error) 
        {
              setIsLoading(false);
              console.log(error.message);
        
        });
  }  
const ChangePage = ({ selected }) => {
        
        setNumber(selected+1);
  };
 
const changeReporttype = (e) => 
{   
    setReportID(e.target.value)
   
    if(e.target.value=="History Report")
    {

          GoToPage("/CHistoryReport");
          setHisDisplay("block");
          setDistDisplay("none");
          setStopDisplay("none");
          setOverSDisplay("none");
    }
    else if(e.target.value=="Distance Report")
    {
        
          GoToPage("/CDistanceReport");
          setDistDisplay("block");
          setHisDisplay("none");
          setStopDisplay("none");
          setOverSDisplay("none");
    }
    else if(e.target.value=="Over Speed Report")
    {     
          GoToPage("/COverSpeedingReport");
          setOverSDisplay("block");
          setHisDisplay("none");
          setDistDisplay("none");
          setStopDisplay("none");
       
    }
    else if(e.target.value=="Stoppage Report")
    {
          GoToPage("/CStoppageReport");
          setStopDisplay("block");
          setHisDisplay("none");
          setDistDisplay("none");
          setOverSDisplay("none");
    }
    else
    {
          setHisDisplay("none");
          setDistDisplay("none");
          setStopDisplay("none");
          setOverSDisplay("none");
    }
} 
const changeVehicle = (e) => 
{   
    //alert(e.target.value.replace(/\s/g, ""));
    setVehicleNo(e.target.value.replace(/\s/g, ""));     
    setTripNo(e.target.value)
} 
const SDatechangeHandler = (e) => 
{   
    setSdate(e.target.value);
    setEdate(e.target.value);
} 
const EDatechangeHandler = (e) => 
{   
    setEdate(e.target.value)
}
const handleChange = (e) => {
setRtpAddress(e.target.value);

};
const ResetPageList=()=>
{
    setSdate("");
    setEdate("");
    setTripNo("");  

}
const FilterGrid = async () => {
    if (!tripNo || tripNo === 0) {
        toast.error("Vehicle number is required.");
        return;
    }

    if (!sdate || !edate) {
        toast.error("Please select Start Date and End Date.");
        return;
    }

    const startDate = new Date(sdate);
    const endDate = new Date(edate);

    if (startDate > endDate) {
        toast.error("From date should be less than to date.");
        return;
    }

    const diffInDays =
        (endDate - startDate) / (1000 * 60 * 60 * 24);

    if (diffInDays > 7 && rtpAddress === "Yes") {
        toast.error(
            "Address selection Date range cannot be more than 7 days."
        );
        return;
    }

    try {
        setIsLoading(true);

        const Account_ID = getUserId();

        setCustID(Account_ID);
        setPost([]);

        const searchparams = {
            accountID: Account_ID,
            vehicleNumber: tripNo,
            fromDate: sdate,
            endDate: edate,
            orderBy: "",
            reqaddress: rtpAddress
        };

        const cacheKey = `HISTORY_${JSON.stringify(searchparams)}`;
 
        let responseData;

        const cachedData = sessionStorage.getItem(cacheKey);
        //alert(cacheKey);
        if (cachedData) 
        {
               responseData = JSON.parse(cachedData);
        } else {
            const rpturl = API_URL + "ClientReport/HISTORY";
           // alert(cachedData);
            const response = await axios.post(
                rpturl,
                searchparams,
                {
                    headers: {
                        "content-type": "application/json"
                    }
                }
            );

            responseData = response.data;

            sessionStorage.setItem(
                cacheKey,
                JSON.stringify(responseData)
            );
        }

        if (!responseData.validStatus) {
            toast.error(responseData.message);
            return;
        }

        let data = responseData.data || [];

        if (rtpAddress === "Yes") {
            data = await Promise.all(
                data.map(async (item) => ({
                    ...item,
                    startAddress: item.startAddress?.trim()
                        ? item.startAddress
                        : await getAddress(
                              item.start_Latitude,
                              item.start_Longitude
                          ),
                    endAddress: item.endAddress?.trim()
                        ? item.endAddress
                        : await getAddress(
                              item.end_Latitude,
                              item.end_Longitude
                          )
                }))
            );
        }

        setPost(data);

        console.log(data);

        setOverSDisplay("none");
        setHisDisplay("block");
        setDistDisplay("none");
        setStopDisplay("none");
    } catch (error) {
        console.error(error);

        toast.error(
            error.response?.data?.message ||
            "No data found!"
        );
    } finally {
        setIsLoading(false);
    }
};
const FilterGrid_old =() => 
{
      
       if(tripNo ==="" || tripNo ===0)
        {
                toast.error("Vehicle number is required.");
                return;
        }  
        else if(sdate==null || sdate=='')
        {
          toast.error("Please Select Date.");
          return;
        }
        else if(sdate > edate)
        {
               toast.error("From date should be less than to date.");
               return;
        }
        else
        {
                setIsLoading(true);
                const Account_ID = getUserId(); 
                setCustID(Account_ID);
                const searchparams = JSON.stringify({
                "accountID": Account_ID,
                "vehicleNumber":tripNo,
                "fromDate":sdate,
                "endDate": edate,
                "orderBy": "",
                "reqaddress":rtpAddress
         });      
 
        setPost([])
        let rpturl="";
        rpturl = API_URL+'ClientReport/HISTORY';                   
         
        axios.post(rpturl, searchparams,
        {  
             "headers":{"content-type": "application/json",},
        })
        .then(function (response) 
        {  
              if(!response.data.validStatus)
              {
                setIsLoading(false);
                toast.error(response.data.message);
              }
              else
              {
                console.log(response.data.data);
                setPost(response.data.data);   
                
                setIsLoading(false); 
                console.log('history'+sdate);  
                
                setOverSDisplay("none");
                setHisDisplay("block");
                setDistDisplay("none");
                setStopDisplay("none");  
                //toast.success(response.data.message);
              }               
          
        })
        .catch(function (error) 
        {
            setIsLoading(false);            
            toast.info("No data found !");
        });
    }
    }
const handleOnSearch = (string, results) => 
{ 
            console.log(string, results)
}

const handleOnHover = (result) =>
 {
            
  // the item hovered
            //SetVeicleNo(items.id);
            //console.log(items.imeiNumber)
 }
const handleOnSelect = (items) => 
{
        console.log(items);
        setVehicleNo(items.vehicleNumber.replace(/\s/g, ""));
        setImeiNumber(items.imeiNumber);
        SearchFillGrid(items.imeiNumber);
       
  
}
  const handleOnFocus = () => 
    {  
            console.log('Focused')
    }

    const formatResult = (items) => {
      return (
      <>      
        <span style={{ display: 'none', textAlign: 'left' }}>{items.id}</span>
        <span style={{ display: 'block', textAlign: 'left' }}>{items.name}</span>
      </>
      )
      }
//End Auto Serch Drop down


const exportStatus = e => {
   const value = e.target.value; 
  setStatusId(e.target.value);
  FillGrid(value);
}
const exportToCSV=()=>
  {
    const newPost = post.map(({ end_Latitude,end_Longitude,haltAddress,haltFromPreviousTrip,start_Latitude,start_Longitude,sno,totalStopTime,totalRunTime,totalIdleTime,mileage, ...rest }) => rest);
         const ws= XLSX.utils.json_to_sheet(newPost);        
         var wscols = [
            {wch:20} ,
            {wch:20} ,
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:20},
            {wch:60},         
            {wch:60}       
        ];
     
        var wsrows = [
           {hpx: 30}
        ];
        ws['!cols'] = wscols;
        ws['!rows']=wsrows;
        let Heading = [['Vehicle No.','Stop No.','Start Date','End Date','Distance in Km.','Average Speed in Km/h','Start Location','End Location']];
        const wb={Sheets:{TripHistory:ws},SheetNames:["TripHistory"]};
        XLSX.utils.sheet_add_aoa(ws, Heading);     
        const excelBuffer= XLSX.write(wb,{bookType:"xlsx",type:"array"});
        const data= new Blob([excelBuffer],{type:fileType});
        FileSaver.saveAs(data,"AvtTripHistoryReport"+".xlsx");   

}
const exportDownload = e => 
{  
  
  const value = e.target.value; 
  //alert(value)

  if(value=="Excel")
  {
      exportToCSV();    
  }
  if(value=="PDF")
  {
       // handlePrint(null, () => tableRef.current);
       onPDFLoad();
  }
}
const onPDFLoad = () =>
  {
    //process.env.REACT_APP_REPORT;    
     var rptURL=PDF_Url + "RptHistory_" + custID + ".pdf"
     //alert(rptURL);
     window.open(rptURL);
  };
  
/*const { onDownload } = useDownloadExcel({
  currentTableRef: tableRef.current,
  filename: "Trip History Details",
  sheet: "TripHistory"
});*/
const handlePrint = useReactToPrint({
  documentTitle: "History Details",
  onBeforePrint: () => console.log("before printing..."),
  onAfterPrint: () => console.log("after printing..."),
  removeAfterPrint: true,
});
const styles = {
headsection: {
    backgroundColor:"black", color:"white",textAlign:"center"
},
tcaption: {
    textAlign:"left",fontWeight:"bold","vertical-align": "middle",width:"15%"
}
}
if (isLoading) 
  {
    return <center>< LoadingSpinner/></center> ;
  }
return (
    <>
      <div className="top-bar clearfix">
      <div className="row justify-content-between">
      <div class="col-12 col-lg-5 d-flex align-item-center">
      <h2 className="m-0"> History Report</h2>                     
     </div>
     <div class="col-12 col-lg-7 d-flex justify-content-end">    
            <select onChange={exportStatus} className="form-control" name="DStatus"   style={{ "backgroundColor":"white",width:"auto", "float": "right","margin-right": "5px","height": "15px"}}   value={statusId} >             
            <option value={"0"}>All</option>
            <option value={"1"}>Recent</option>                        
            </select>
            <select onChange={exportDownload}  className="form-control w-auto" name="DDownload" >
            <option value={"Download"}>Download</option>    
            <option value={"Excel"}>Excel</option>    
            <option value={"PDF"}>PDF</option>                     
            </select>
     </div>
     </div>
     </div>
     <div className="container-fluid p-3">

  <div class="card mb-3 shadow no-border border-0">
  <div class="card-body">
  <div class="row align-items-end"> 
  <div class="col-sm-3 col-lg-2">Report Type <span style={{color: "red"}}>&nbsp;*</span>
      <select className="form-control"  name="reportType" value={reportID} onChange={changeReporttype} >
       <option value={0}>Select Report Type</option>
              {
                 arrayReportType.map((e, key) => 
                  {
                         return <option key={key} value={e.reportType}>{e.reportType}</option>;
                  })
               }
       </select>
     </div>     
    <div class="col-sm-3 col-lg-2">Vehicle# <span style={{color: "red"}}>&nbsp;*</span>
    <select className="form-control"  name="startAddress" value={tripNo} onChange={changeVehicle} >
    <option value={0}>Select Vehicle</option>
              {
                  arrayvehicle.map((e, key) => 
                  {
                         return <option key={key} value={e.vehicleNumber}>{e.vehicleNumber}</option>;
                  })
               }
    </select>
    </div>     
    
    <div class="col-sm-3 col-lg-2"> Date <span style={{color: "red"}}>&nbsp;*</span>
    <input class="form-control" aria-label="SDate" onChange={SDatechangeHandler} value={sdate} min={min_Date} type="date" />
    </div> 
    <div class="col-sm-3 col-lg-2">End Date
    <input class="form-control" aria-label="EDate" onChange={EDatechangeHandler} value={edate}  type="date" />
    </div> 
    <div class="col-sm-3 col-lg-2">Address
    <input  type="radio" name="rtpAddress" value="Yes" checked={rtpAddress === "Yes"} onChange={handleChange}/>Yes
    <input  type="radio" name="rtpAddress" value="No" checked={rtpAddress === "No"} onChange={handleChange}/>No
    </div>
    {/*<div class="col-sm-3 col-lg-2">End Date
    <input class="form-control" aria-label="EDate" onChange={EDatechangeHandler} value={edate}  type="date" />
    </div>    */}
    
    <div class="col-sm-4 col-lg-2">
    <button type="button" class="btn btn-primary2 mt-20" tabindex="6" id="btnSearchNew" onClick={FilterGrid} >Search</button>
    <button type="button" class="btn btn-secondary mt-20" id="btnResetNew" tabindex="7" onClick={ResetPageList}>Reset
    </button></div>
    </div>    
  </div>
</div>

<div class="card mb-3 shadow no-border border-0">
  {/* 
<div class="card-body p-0" style={{display: distDisplay }}>
<table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
        <thead>
            <tr>
                <th width="20%"  style={{textAlign:"center","cursor": "pointer"}}>Vehicle No. </th>                
                <th width="20%" onClick={()=>sorting("tripStartDateTime") } style={{textAlign:"center","cursor": "pointer"}}> From Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="20%" onClick={()=>sorting("tripEndDateTime") } style={{textAlign:"center","cursor": "pointer"}}> To Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="20%" onClick={()=>sorting("distance") } style={{textAlign:"center","cursor": "pointer"}}>Distance Travelled &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="20%" onClick={()=>sorting("averageSpeed") } style={{textAlign:"center","cursor": "pointer"}}>Time Taken &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
            </tr>
        </thead>
        <tbody>        
        {currentPost.map((itemm) => 
        {
        return (
            <>                             
            <tr key={itemm.tripno}>              
              <td style={{textAlign:"center"}}>{itemm.vehicleNo}</td>       
              <td style={{textAlign:"left"}}>{itemm.fromDate}</td>                     
              <td style={{textAlign:"left"}}>{itemm.toDate}</td>             
              <td style={{textAlign:"left"}}>{itemm.distanceTravelled}</td>              
              <td style={{textAlign:"left"}}>{itemm.timeTaken} km</td>
             
            </tr>
              </>
                );
          })}
          </tbody>
        </table>

        <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={PageCount}
            onPageChange={ChangePage}     
            disableInitialCallback={true}
            initialPage={0}
            containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}></ReactPaginate>
</div>    

<div class="card-body p-0" style={{display: stopDisplay }}>
<table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
        <thead>
            <tr>
                <th width="20%"  style={{textAlign:"center","cursor": "pointer"}}>Vehicle No. </th>                
                <th width="20%" onClick={()=>sorting("tripStartDateTime") } style={{textAlign:"center","cursor": "pointer"}}> Date &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="20%" onClick={()=>sorting("tripEndDateTime") } style={{textAlign:"center","cursor": "pointer"}}> Duration &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="20%" onClick={()=>sorting("distance") } style={{textAlign:"center","cursor": "pointer"}}>Location &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                          
            </tr>
        </thead>
        <tbody>
       
                                  
            <tr >              
              <td style={{textAlign:"left"}}></td>       
              <td style={{textAlign:"center"}}></td>                     
              <td style={{textAlign:"right"}}></td>             
              <td style={{textAlign:"center"}}></td>            
                   
            </tr>
            
         
          </tbody>
        </table>

        <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={PageCount}
            onPageChange={ChangePage}     
            disableInitialCallback={true}
            initialPage={0}
            containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}></ReactPaginate>
</div>   
<div class="card-body p-0" style={{display: overSDisplay}}>
<table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
        <thead>
            <tr>
                <th width="10%"  style={{textAlign:"center","cursor": "pointer"}}>Vehicle No. </th>                
                <th width="10%" onClick={()=>sorting("maxSpeed") } style={{textAlign:"center","cursor": "pointer"}}> Speed &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="55%" onClick={()=>sorting("place") } style={{textAlign:"center","cursor": "pointer"}}> Place &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="10%" onClick={()=>sorting("time") } style={{textAlign:"center","cursor": "pointer"}}>Time &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
                <th width="15%" onClick={()=>sorting("duration") } style={{textAlign:"center","cursor": "pointer"}}>Duration &nbsp;&nbsp; <i class="fa-sharp fa-solid fa-sort"></i></th>
            </tr>
        </thead>
        <tbody>        
        {currentPost.map((itemm) => 
        {
        return (
            <>                             
            <tr key={itemm.tripno}>              
              <td style={{textAlign:"left"}}>{itemm.vehicleNo}</td>       
              <td style={{textAlign:"left"}}>{itemm.maxSpeed}</td>                     
              <td style={{textAlign:"left"}}>{itemm.place}</td>             
              <td style={{textAlign:"left"}}>{itemm.time}</td>   
              <td style={{textAlign:"left"}}>{itemm.duration}</td> 
                         
            
             
            </tr>
              </>
                );
          })}
          </tbody>
        </table>

        <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={PageCount}
            onPageChange={ChangePage}     
            disableInitialCallback={true}
            initialPage={0}
            containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}></ReactPaginate>
</div>   
*/}
<div class="card-body p-0" style={{display: hisDisplay }}>
<table ref={tableRef} class="table table-striped table-bordered table-hover" style={{width:"100%"}}>
   <thead>
    <tr>
        <th width="7%" style={{ textAlign: "center", cursor: "pointer" }}>
            Stop No.
        </th>

        <th width="9%" style={{ textAlign: "center", cursor: "pointer" }}>
            Vehicle No.
        </th>

        <th
            width="10%"
            onClick={() => sorting("tripStartDateTime")}
            style={{ textAlign: "center", cursor: "pointer" }}
        >
            Start Date &nbsp;&nbsp;
            <i className="fa-sharp fa-solid fa-sort"></i>
        </th>

        <th
            width="10%"
            onClick={() => sorting("tripEndDateTime")}
            style={{ textAlign: "center", cursor: "pointer" }}
        >
            End Date &nbsp;&nbsp;
            <i className="fa-sharp fa-solid fa-sort"></i>
        </th>

        <th
            width="10%"
            onClick={() => sorting("distance")}
            style={{ textAlign: "center", cursor: "pointer" }}
        >
            Distance &nbsp;&nbsp;
            <i className="fa-sharp fa-solid fa-sort"></i>
        </th>

        <th
            width="10%"
            onClick={() => sorting("averageSpeed")}
            style={{ textAlign: "center", cursor: "pointer" }}
        >
            Average Speed &nbsp;&nbsp;
            <i className="fa-sharp fa-solid fa-sort"></i>
        </th>

        {rtpAddress === "Yes" ? (
            <>
                <th
                    width="23%"
                    onClick={() => sorting("startAddress")}
                    style={{ textAlign: "center", cursor: "pointer" }}
                >
                    Start Address &nbsp;&nbsp;
                    <i className="fa-sharp fa-solid fa-sort"></i>
                </th>

                <th
                    width="23%"
                    onClick={() => sorting("endAddress")}
                    style={{ textAlign: "center", cursor: "pointer" }}
                >
                    End Address &nbsp;&nbsp;
                    <i className="fa-sharp fa-solid fa-sort"></i>
                </th>
            </>
        ) : (
            <>
                <th
                    width="23%"
                    onClick={() => sorting("startLatitude")}
                    style={{ textAlign: "center", cursor: "pointer" }}
                >
                    Start Latitude &nbsp;&nbsp;
                    <i className="fa-sharp fa-solid fa-sort"></i>
                </th>

                <th
                    width="23%"
                    onClick={() => sorting("endLatitude")}
                    style={{ textAlign: "center", cursor: "pointer" }}
                >
                    End Latitude &nbsp;&nbsp;
                    <i className="fa-sharp fa-solid fa-sort"></i>
                </th>
            </>
        )}
    </tr>
</thead>
        <tbody>
        {currentPost.map((devdata) => 
        {
        return (
            <>                             
            <tr key={devdata.tripno}>
    <td style={{ textAlign: "center" }}>{devdata.tripno}</td>
    <td style={{ textAlign: "center" }}>{devdata.vehicleNumber}</td>
    <td style={{ textAlign: "center" }}>{devdata.tripStartDateTime}</td>
    <td style={{ textAlign: "center" }}>{devdata.tripEndDateTime}</td>
    <td style={{ textAlign: "center" }}>{devdata.distance} km</td>
    <td style={{ textAlign: "center" }}>{devdata.averageSpeed} km/hr</td>

    {rtpAddress === "Yes" ? (
        <>
            <td>{devdata.startAddress}</td>
            <td>{devdata.endAddress}</td>
        </>
    ) : (
        <>
            <td>
                {devdata.start_Latitude},{devdata.start_Longitude}
            </td>
            <td>
                {devdata.end_Latitude},{devdata.end_Longitude}
            </td>
        </>
    )}
</tr>
              </>
                );
          })}
          </tbody>
        </table>
        <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={PageCount}
            onPageChange={ChangePage}     
            disableInitialCallback={true}
            initialPage={0}
            containerClassName={'pagination justify-content-end'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}></ReactPaginate>
</div>
</div>  </div>
            <ToastContainer position="bottom-right" autoClose={4000} theme="light"/>              
        </>
    );}

export default HistoryReport;
